import { createContext } from 'react'

import { Worker } from 'twilio-taskrouter'

type TwilioWorkerContextValue = {
  worker: Worker | null
  setWorker: (value: Worker | null) => void
}
export const TwilioWorkerContext = createContext<TwilioWorkerContextValue>({
  worker: null,
  setWorker: () => {},
})
